import React, { useContext, useState } from 'react';
import { LedgerDialog } from 'components/Dialogs';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import DCFApproachContext from 'pages/ValuationsAllocation/approaches/DiscountCashFlow/context/DCFApproachContext';
import ValuationContext from 'pages/ValuationsAllocation/ValuationContext';
import { getObjectValue } from 'utilities';
import DialogHeader from './DialogHeader';
import { WACCLedgerProps } from './types';


const WACCLedger = (props: WACCLedgerProps) => {
  const { closeDialog, dcfWacc } = getObjectValue(props);
  const { workbook } = useContext(ValuationContext);
  const { onChange: onWorkbookChange } = useContext(DCFApproachContext);
  const [cells, setCells] = useState(dcfWacc.cells);
  const [waccInfo, setWaccInfo] = useState(Number(dcfWacc.cells.wacc.value || 0) * 100);

  const onChange = (cell: ICell, expr: string) => {
    if (onWorkbookChange) onWorkbookChange(cell, expr);
    setWaccInfo(Number(dcfWacc.cells.wacc.value || 0) * 100);
  };

  const waccLedgerSheetProps = {
    ...dcfWacc,
    sheet: dcfWacc,
    onChange,
    showToolbar: true,
    workbook,
    className: 'valuations-dcf-wacc-ledger-table',
    cells,
    updateCells: setCells,
  };

  return (
    <LedgerDialog
      id="current-waccledger"
      dialogHeader={<DialogHeader waccInfo={waccInfo} />}
      title=""
      actionButtonText={{ cancel: 'Done' }}
      onClose={closeDialog}>
      <ScalarSpreadsheet {...waccLedgerSheetProps} />
    </LedgerDialog>
  );
};

export default WACCLedger;
